"use client";

import { ReactNode } from "react";
import { HomeBannerContext } from "./home-banners-context";

export const HomeBannersProvider = ({
  children,
  practiceExamStatus,
}: {
  children: ReactNode;
  practiceExamStatus: ExamPracticeExamStatusVM;
}) => {
  return (
    <HomeBannerContext.Provider value={{ practiceExamStatus }}>
      {children}
    </HomeBannerContext.Provider>
  );
};
